import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/account_information/404'
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    // 登入
    path: '/login',
    name: 'loginPage',
    component: () => import('../views/loginPage'),
    meta: { title: '登入' }
  },
  {
    // 登出，for Revit
    path: '/logout',
    name: 'logout',
    component: () => import('../views/logoutPage'),
    meta: { title: '登出' }
  },
  {
    // 註冊
    path: '/register',
    name: 'registerPage',
    component: () => import('../views/registerPage'),
    meta: { title: '註冊' }
  },
  {
    // 選擇專案
    path: '/select_organization',
    name: 'selectOrganization',
    component: () => import('../views/selectOrganization'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '選擇專案' }
  },
  {
    path: '/account_information',
    name: 'accountInformation',
    redirect: '/account_information/home',
    component: () => import('../views/accountInformationPage'),
    children: [
      {
        // 總覽
        path: 'home',
        name: 'home',
        component: () => import('../views/homePage'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '總覽' }
      },
      {
        // 個人資料
        path: 'personal_information',
        name: 'personalInfo',
        component: () => import('../views/personalInfo'),
        meta: { requiresAuth: true, title: '個人資料' }
      },
      {
        // 安全性設定
        path: 'security_settings',
        name: 'securitySettings',
        component: () => import('../views/securitySettings'),
        meta: { requiresAuth: true, title: '安全性設定' }
      },
      {
        // 組織與權限管理
        path: 'organization_and_permission_management',
        name: 'organizationAndPermissionManagement',
        component: () => import('../views/organizationAndPermissionManagement'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '組織與權限管理' }
      },
      {
        // 方案總覽與下載 - 第一頁
        path: 'plan_overview',
        name: 'planOverview',
        component: () => import('../views/planOverview'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '方案總覽與下載' }
      },
      {
        // 方案總覽與下載 - 第二頁
        path: 'plan_overview_option/:id',
        name: 'planOverviewOption',
        component: () => import('../views/planOverviewOption'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '方案總覽與下載' }
      },
      {
        // 方案總覽與下載 - 第三頁
        path: 'plan_overview_option_detail/:id',
        name: 'planOverviewOptionDetail',
        component: () => import('../views/planOverviewOptionDetail'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '方案總覽與下載' }
      },
      {
        // 我的方案與帳單
        path: 'plan_and_billing/:id?',
        name: 'planAndBilling',
        component: () => import('../views/planAndBilling'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '我的方案與帳單' }
      },
      {
        // 404
        path: '404',
        name: '404',
        component: () => import('../views/404'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '找不到頁面' }
      },
      // only 開發人員
      {
        // 訊息推播
        path: 'message_push',
        name: 'messagePush',
        component: () => import('../views/messagePush'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '訊息推播' }
      },
      {
        // 諮詢名單
        path: 'consultation_list',
        name: 'consultationList',
        component: () => import('../views/consultationList'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '諮詢名單' }
      },
      {
        // 訂單管理
        path: 'order_management',
        name: 'orderManagement',
        component: () => import('../views/orderManagement'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '訂單管理' }
      },
      {
        // 待審核元件
        path: 'unreviewed_components',
        name: 'unreviewedComponents',
        component: () => import('../views/unreviewedComponents'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '待審核元件' }
      },
      {
        // 使用教學
        path: 'tutorial',
        redirect: "/user_guidebook/create_first_project",
      },
      {
        // 歷代版本更新紀錄
        path: '/changelog',
        name: 'changelogPage',
        component: () => import('../views/changelog'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '版本更新紀錄' }
      },
    ],
  },
  {
    // 安全性設定 - 刪除帳戶與資料
    path: '/delete_account',
    name: 'deleteAccount',
    component: () => import('../views/deleteAccount'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '刪除帳戶與資料' }
  },
  {
    // 安全性設定 - 恢復帳號與資料
    path: '/restore_account_and_data',
    name: 'restoreAccountAndData',
    component: () => import('../views/restoreAccountAndData'),
    meta: { requiresAuth: true, title: '恢復帳號與資料' }
  },
  {
    // 刪除組織
    path: '/delete_org',
    name: 'deleteOrg',
    component: () => import('../views/deleteOrg'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '刪除組織' }
  },
  {
    // 恢復組織
    path: '/restore_org',
    name: 'restoreOrg',
    component: () => import('../views/restoreOrg'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '恢復組織' }
  },
  {
    // 啟用序號
    path: '/check_serial_number',
    name: 'checkSerialNumber',
    component: () => import('../views/checkSerialNumber'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true, title: '啟用序號' }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 每次換頁後自動更新瀏覽器標題
router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} | 萃思科技 MindLogic` : '萃思科技 MindLogic'
})

export default router